import { MenuList, Popover } from '@mui/material'
import { FloatingMenuPopoverHeader } from './FloatingMenuPopoverHeader'
import { floatingMenuPaperSx } from './floatingMenuPaperSx'
import styles from './index.module.scss'

/**
 * @param {import('@mui/material').PopoverProps & {
 *   header?: import('react').ReactNode, paperClassName?: string, paperSx?: import('@mui/material').SxProps,
 *   listRef: import('react').RefObject<HTMLElement | null>, menuListId?: string, menuListAriaLabel: string,
 *   listClassName?: string, entries: import('react').ReactNode,
 * }} props
 */
export function FloatingMenuPopover({ open, anchorEl, onClose, hideBackdrop, anchorOrigin, transformOrigin, header, paperClassName, paperSx, listRef, menuListId, menuListAriaLabel, listClassName, entries }) {
  return (
    <Popover open={open} anchorEl={anchorEl} onClose={onClose} hideBackdrop={hideBackdrop} anchorOrigin={anchorOrigin} transformOrigin={transformOrigin} marginThreshold={8} slotProps={{ paper: { elevation: 0, className: [styles.paper, paperClassName].filter(Boolean).join(' '), sx: floatingMenuPaperSx(Boolean(header), paperSx) } }}>
      <FloatingMenuPopoverHeader header={header} />
      <MenuList ref={listRef} id={menuListId} dense disablePadding aria-label={menuListAriaLabel} className={[styles.list, listClassName].filter(Boolean).join(' ')} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'stretch', width: '100%', minWidth: 0, padding: 0 }}>
        {entries}
      </MenuList>
    </Popover>
  )
}
